import { combineReducers } from '@reduxjs/toolkit';
import order from './orderSlice';

const orderReducers = combineReducers({
  order,
});

export default orderReducers;
